module.exports = __webpack_public_path__ + "static/media/american_express.2ca27720.svg";